import { render, staticRenderFns } from "./AnswerOptions.vue?vue&type=template&id=169b873c&scoped=true"
import script from "./AnswerOptions.vue?vue&type=script&lang=js"
export * from "./AnswerOptions.vue?vue&type=script&lang=js"
import style0 from "./AnswerOptions.vue?vue&type=style&index=0&id=169b873c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169b873c",
  null
  
)

export default component.exports